import { store } from '../../../lib/store'
import { dateConvertion } from '../../main-ui/common/commonfunctions'

function normaliseColor(color) {
  if (!color) return '#9ecc3b'
  let c = color.startsWith('#') ? color : '#' + color
  if (c.length > 7) c = '#' + c.slice(-6)
  return c
}

export default function buildPopupContent(markerObj, onEdit, onShare, onDelete, onHuntWind, popup) {
  const { userPreferences } = store.getState()
  const formattedDate = dateConvertion(markerObj.created)
  const alt = userPreferences?.units === 'imperial'
    ? ((markerObj.altitude ?? 0) * 3.28084).toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' ft'
    : (markerObj.altitude ?? 0).toLocaleString('en-IN', { maximumFractionDigits: 0 }) + ' m'
  const colorValue = normaliseColor(markerObj.color)
  const iconUrl = markerObj.markerType?.vectorIconUrl ?? ''
  const fallbackIcon = 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/svg/Location.svg'
  const clipId = `cc3d-${markerObj.id}`

  const isHuntStand = markerObj.markerType?.usageFlag === 3
  const wrap = document.createElement('div')
  wrap.style.cssText = `padding:10px;height:165px;width:${isHuntStand ? '300px' : '260px'};background-color:black;visibility:visible;border-radius:10px;position:relative`
  wrap.innerHTML = `
    <div class="info-window-header-container">
      <div style="width:90%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-weight:bold;font-size:13px;color:#fff">${markerObj.name ?? ''}</div>
      <div class="info-window-closeicon">
        <a id="iw-close" style="cursor:pointer">
          <img style="width:20px;object-fit:cover;float:right;margin-top:-10px" src="/asset/close.png" alt="Close"/>
        </a>
      </div>
    </div>
    <div style="width:100%;display:flex;position:relative;z-index:111">
      <div style="width:55%">
        <h6 class="info-box-head-date">Created: <span class="info-box-head-date">${formattedDate ?? 'N/A'}</span></h6>
        <h6 class="info-box-head">Elev: <span class="info-box-span">${alt}</span></h6>
        <h6 class="info-box-head">Lattitude: <span class="info-box-span">${Number(markerObj.latitude).toFixed(5)}</span></h6>
        <h6 class="info-box-head">Longitude: <span class="info-box-span">${Number(markerObj.longitude).toFixed(5)}</span></h6>
        <div style="display:flex;margin-top:10px;margin-right:10px">
          <div style="width:${isHuntStand ? '40' : '50'}px;height:55px;display:flex;flex-direction:column;align-items:center;justify-content:center">
            <a id="iw-share" style="cursor:pointer">
              <div class="info-window-bottons">
                <img style="width:50%;height:50%;object-fit:cover" src="/asset/shared.png"/>
              </div>
            </a>
            <p>Share</p>
          </div>
          <div style="width:${isHuntStand ? '40' : '50'}px;height:55px;display:flex;flex-direction:column;align-items:center;justify-content:center">
            <a id="iw-edit" style="cursor:pointer">
              <div class="info-window-bottons">
                <img style="width:50%;height:50%;object-fit:cover" src="/asset/pencil.png" alt="Edit"/>
              </div>
            </a>
            <p>Edit</p>
          </div>
          ${isHuntStand ? `
          <div style="width:40px;height:55px;display:flex;flex-direction:column;align-items:center;justify-content:center">
            <a id="iw-huntwind" style="cursor:pointer">
              <div class="info-window-bottons">
                <img style="width:50%;height:50%;object-fit:cover" src="/asset/Wind-Icon.png"/>
              </div>
            </a>
            <p>Hunt Wind</p>
          </div>` : ''}
          <div style="width:${isHuntStand ? '40' : '50'}px;height:55px;display:flex;flex-direction:column;align-items:center;justify-content:center">
            <a id="iw-delete" style="cursor:pointer">
              <div class="info-window-bottons">
                <img style="width:50%;height:50%;object-fit:cover" src="/asset/bin.png"/>
              </div>
            </a>
            <p>Delete</p>
          </div>
        </div>
      </div>
      <div style="width:115px;height:125px;margin-top:10px;display:flex;justify-content:center;align-items:normal">
        <svg class="info-marker-default-size" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <clipPath id="${clipId}">
              <circle cx="8" cy="6" r="5"/>
            </clipPath>
          </defs>
          <rect width="16" height="16" fill="none"/>
          <path d="M8,0C4.688,0,2,2.688,2,6c0,6,6,10,6,10s6-4,6-10C14,2.688,11.312,0,8,0z M8,8C6.344,8,5,6.656,5,5s1.344-3,3-3s3,1.344,3,3 S9.656,8,8,8z" fill="${colorValue}"/>
          <circle cx="8" cy="6" r="5" fill="#FFFFFF"/>
          <image xlink:href="${iconUrl || fallbackIcon}" x="4" y="1.5" width="8" height="8" clip-path="url(#${clipId})"/>
        </svg>
      </div>
    </div>`

  wrap.querySelector('#iw-close').addEventListener('click', e => {
    e.stopPropagation()
    popup.remove()
  })
  wrap.querySelector('#iw-edit')?.addEventListener('click', e => {
    e.stopPropagation()
    onEdit()
  })
  wrap.querySelector('#iw-share').addEventListener('click', e => {
    e.stopPropagation()
    onShare()
  })
  wrap.querySelector('#iw-delete').addEventListener('click', e => {
    e.stopPropagation()
    onDelete()
  })
  wrap.querySelector('#iw-huntwind')?.addEventListener('click', e => {
    e.stopPropagation()
    onHuntWind()
  })

  return wrap
}
